import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, watchEffect } from "@nuxtjs/composition-api";

import { useRetailerProduct, useRetailerProductImages } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'RetailerProductImages',
  props: {
  retailerProductId: {
    type: String,
    required: true,
  },
  ltkId: {
    type: String,
    default: "",
  },
  selectedProductVariantId: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const { retailerProductId, ltkId, selectedProductVariantId } = toRefs(props);
const carouselItemIndex = ref(0);
const fullscreenDialog = ref(false);

const { retailerProduct } = useRetailerProduct(retailerProductId);
const { imageUrls, smallImagesProps, heroImagesProps, fullImagesProps } = useRetailerProductImages(
  retailerProductId,
  ltkId,
);

const currentItemBadgeText = computed(() => {
  return `${carouselItemIndex.value + 1}/${imageUrls.value.length}`;
});

watchEffect(() => {
  if (!retailerProduct) {
    return;
  }
  const selectedProductVariant = retailerProduct.value?.variants.find(
    ({ id }) => id === selectedProductVariantId.value,
  );
  const imageIndex = imageUrls.value.findIndex((imageUrl) => imageUrl === selectedProductVariant?.imageUrl);
  if (imageIndex >= 0) {
    carouselItemIndex.value = imageIndex;
  }
});

return { __sfc: true,props, retailerProductId, ltkId, selectedProductVariantId, carouselItemIndex, fullscreenDialog, retailerProduct, imageUrls, smallImagesProps, heroImagesProps, fullImagesProps, currentItemBadgeText }
}

})